import { combineEpics, Epic } from 'redux-observable';

import { Action } from '../../actions';
import {
    changeReportsColumnsOrder,
    changeReportsColumnsVisibility,
    HANDLE_REPORTS_COLUMNS_ORDER_CHANGE,
    HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE,
    HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE,
    HandleReportsColumnsOrderChangeAction,
    HandleReportsColumnsVisibilityChangeAction,
    HandleReportsColumnsWidthUpdateAction,
    updateReportsColumnsWidthData
} from '../../actions/reportsClient';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { EpicDeps } from '../../service/StoreFactory';
import { reportsClient } from '../../typings/common';
import { State } from '../../typings/state';

export const handleReportsColumnsVisibilityChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$
        .ofType(HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE)
        .map((action: HandleReportsColumnsVisibilityChangeAction) => {
            const { columnsSettings } = store$.value.reportClient;
            const settings = getColumnsVisibilitySettings(columnsSettings, action.columns, reportsClient);

            LocalStorage.setItem(StorageKeyType.reportsSettings, settings);

            return changeReportsColumnsVisibility(settings);
        });
};

export const handleReportsColumnsOrderChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.ofType(HANDLE_REPORTS_COLUMNS_ORDER_CHANGE).map((action: HandleReportsColumnsOrderChangeAction) => {
        const { columnsSettings } = store$.value.reportClient;

        const settings = getColumnSettingsWithUpdatedOrder(columnsSettings, action.columnOrder, reportsClient);

        LocalStorage.setItem(StorageKeyType.reportsSettings, settings);

        return changeReportsColumnsOrder(settings[reportsClient].columnOrder);
    });
};

export const handleReportsColumnsWidthUpdateEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.ofType(HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE).map((action: HandleReportsColumnsWidthUpdateAction) => {
        const { columnsSettings } = store$.value.reportClient;
        const settings = getColumnsWidthSettings(columnsSettings, action.key, action.width, reportsClient, false);

        LocalStorage.setItem(StorageKeyType.reportsSettings, settings);

        return updateReportsColumnsWidthData(settings);
    });
};

export const reportHelpersEpic = combineEpics(
    handleReportsColumnsVisibilityChangeEpic,
    handleReportsColumnsOrderChangeEpic,
    handleReportsColumnsWidthUpdateEpic
);
